class DecodeContacts {
  static async init () {
    return new DecodeContacts()
  }

  constructor () {
    $('.contact-tracking.email').each((_, value) => {
      let link = $(value)

      if (link.data('encoded')) {
        let item = atob(link.data('encoded'))
        link.attr('href', 'mailto:' + item)
        if (link.text().length === 0) { link.text(item) }
      }
    })

    $('.contact-tracking.phone').each((_, value) => {
      let link = $(value)

      if (link.data('encoded')) {
        let item = atob(link.data('encoded'))
        link.attr('href', 'tel:' + item.replace(/\D/g, ''))
        if (link.text().length === 0) { link.text(item) }
      }
    })
  }
}

export default DecodeContacts
